import DuckEntity from './DuckEntity';

const authPaymentAccounts = new DuckEntity('authPaymentAccounts');

export default authPaymentAccounts.reducer;
export { authPaymentAccounts };
